import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=05052c0a&"
import script from "./empty.vue?vue&type=script&lang=ts&"
export * from "./empty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05052c0a')) {
      api.createRecord('05052c0a', component.options)
    } else {
      api.reload('05052c0a', component.options)
    }
    module.hot.accept("./empty.vue?vue&type=template&id=05052c0a&", function () {
      api.rerender('05052c0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/empty.vue"
export default component.exports